import { Button } from '@mui/material';
import React from 'react';
import * as XLSX from 'xlsx';
import Iconify from '../iconify/Iconify';

const ExportExcel = ({ nameFile, data }) => {
    const handleExport = () => {
        // Dữ liệu cần xuất Excel
        const data = [
            ['Tên', '', 'Địa chỉ'],
            ['John Doe', '123 Đường ABC'],
            ['Jane Smith', '456 Đường XYZ'],
        ];

        // Tạo workbook mới
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.aoa_to_sheet(data);

        // Gộp ô tiêu đề
        const mergeRange = { s: { r: 0, c: 0 }, e: { r: 0, c: 1 } };
        worksheet['!merges'] = [mergeRange];

        // Thêm worksheet vào workbook
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Danh sách');

        // Xuất file Excel
        XLSX.writeFile(workbook, 'danh_sach.xlsx');
    };
    return (
        <Button onClick={handleExport} variant="contained" startIcon={<Iconify icon="eva:plus-fill" />}>
            New User
        </Button>
    );
};

export default ExportExcel;
